import { createContext, useState, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { Spinner } from "app/components";
import { useParams } from "react-router-dom";
import { ErrorMessage } from "app/components/error-message";
import { empresasService } from "app/services";

const PaginaWebContext = createContext();

const initialState = {
  pagina_web_url: "",
  pagina_web_principal: false,
};

export function PaginaWebProvider({ children }) {
  const params = useParams();

  const [paginaWeb, setPaginaWeb] = useState(initialState);
  const [isEditing, setEditing] = useState(false);

  const paginaWebQuery = useQuery({
    queryKey: [
      "empresa:get:pagina-web",
      params.empresa_id,
      params.pagina_web_id,
    ],
    queryFn: () =>
      empresasService.getPaginaWeb({
        empresaId: params.empresa_id,
        paginaWebId: params.pagina_web_id,
      }),
    onSuccess: (data) => {
      setPaginaWeb(data);

      setEditing(true);
    },
    enabled: !!params.pagina_web_id,
  });

  if (!!paginaWebQuery.isLoading && !!params.pagina_web_id) {
    return <Spinner label="Cargando la dirección de página web..." />;
  } else if (!!paginaWebQuery.isFetching && !!params.pagina_web_id) {
    return <Spinner label="Recuperando la dirección de página web..." />;
  } else if (!!paginaWebQuery.isRefetching && !!params.pagina_web_id) {
    return <Spinner label="Recargando la dirección de página web..." />;
  } else if (!!paginaWebQuery.isError) {
    return <ErrorMessage message={paginaWebQuery.error.response.statusText} />;
  }

  return (
    <PaginaWebContext.Provider
      value={{
        paginaWeb,
        setPaginaWeb,
        isEditing,
      }}
    >
      {children}
    </PaginaWebContext.Provider>
  );
}

export function usePaginaWebContext() {
  const paginaWebContext = useContext(PaginaWebContext);

  if (!paginaWebContext) {
    throw new Error(
      "usePaginaWebContext should be used inside the PaginaWebProvider."
    );
  }

  return paginaWebContext;
}
